const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14.655 7.5H12.5V5.345l2.5-2.5v1.322c0 .46.373.833.833.833h1.322zM8.333 18.333A6.667 6.667 0 018.333 5c.887 0 1.728.18 2.5.495v2.493l-.205.205A4.15 4.15 0 008.333 7.5a4.166 4.166 0 104.167 4.167c0-.85-.258-1.637-.693-2.295l.205-.205h2.493c.315.772.495 1.615.495 2.5a6.667 6.667 0 01-6.667 6.666zm2.5-6.666a2.5 2.5 0 11-2.5-2.5c.386 0 .746.094 1.072.25l-1.66 1.66a.831.831 0 00.588 1.423.835.835 0 00.59-.244l1.66-1.66c.156.325.25.686.25 1.07zm9.104-7.82a.835.835 0 00-.77-.514h-2.5v-2.5a.834.834 0 00-1.423-.589l-3.727 3.728a8.267 8.267 0 00-3.184-.639 8.333 8.333 0 108.334 8.334 8.27 8.27 0 00-.639-3.184l3.728-3.727a.832.832 0 00.18-.908z"
});

const SvgHeading = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    width: 20,
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHeading, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/heading.da0c2035.svg";
export { ForwardRef as ReactComponent };